import { ColumnsType } from 'antd/lib/table'
import { renderShipmentCalculatedValue } from '../../components/shipment-calculated-value/render-shipment-calculated-value'
import formatNumber from '../../helpers/formatters/format-any-number'
import renderDate from '../../helpers/tables/render-date'
import RewindJob from '../../types/api/rewind-job'
import ShipmentPosition from '../../types/api/shipment-position'
import formatMachineBrands from '../../helpers/calculations/formatters/format-machine-brands'
import RewindJobExecutor from '../../types/api/rewind-job-executor'
import renderDatetime from '../../helpers/tables/render-datetime'
import ActionsCell from './components/actions-cell/actions-cell'
import JobStatusCell from './components/job-status-cell/job-status-cell'
import { MaterialColumnCell } from '../schedules/flexo/components/cells/material-column-cell'
import formatDuration from '../../helpers/date-time/format-duration'
import { formatRollerDisplay } from '../../helpers/format-roller-display'
import { MaterialRequirement } from '../../types/api/components/material/material-requirements'

export const columns: ColumnsType<RewindJob> = [
    {
        dataIndex: 'id',
        title: 'Номер',
        width: 60,
    },
    {
        dataIndex: ['shipment', 'clientDeliveryDate'],
        title: 'Дата поставки',
        width: 70,
        render: v => (v ? renderDate(v) : '—'),
    },
    {
        dataIndex: ['shipment', 'client', 'name'],
        title: 'Клиент',
    },
    {
        dataIndex: ['shipment', 'shipment_positions'],
        title: 'Тираж',
        render(v: ShipmentPosition[] | null) {
            return formatNumber((v ?? []).reduce((acc, item) => acc + item.copies, 0))
        },
    },
    {
        dataIndex: ['shipment', 'materialRequirements'],
        title: 'Материал',
        width: 80,
        render(v: MaterialRequirement[] | null) {
            return <MaterialColumnCell value={v ?? []} />
        },
    },
    {
        dataIndex: ['shipment', 'calculated', 'materialLength'],
        title: 'Метраж',
        width: 60,
        render(_v, r: RewindJob) {
            return renderShipmentCalculatedValue(r.shipment, calculated =>
                calculated?.materialLength == null
                    ? '—'
                    : Math.round(calculated.materialLength * 1000) / 1000
            )
        },
    },
    {
        dataIndex: ['shipment', 'bushing'],
        title: 'Втулка',
        width: 80,
    },
    {
        dataIndex: ['shipment', 'stamp', 'roller', 'roller'],
        title: 'Вал',
        render(_v, record) {
            const shipment = record.shipment
            if (!shipment) return '—'

            const roller = shipment.withoutCutting
                ? shipment.virtualStamp?.roller?.roller
                : shipment.stamp?.roller?.roller

            return formatRollerDisplay(roller) ?? '—'
        },
    },
    {
        dataIndex: ['shipment', 'calculated', 'commonTime'],
        title: 'Время тиража',
        width: 120,
        render(_v, r: RewindJob) {
            return renderShipmentCalculatedValue(r.shipment, calculated =>
                calculated?.commonTime == null ? '—' : formatDuration(calculated.commonTime)
            )
        },
    },
    {
        dataIndex: 'machine',
        title: 'Приор. станок',
        render(_v, record) {
            return record.shipment ? formatMachineBrands(record.shipment) || '—' : '—'
        },
    },
    {
        dataIndex: ['rewind_job_executors'],
        title: 'Начало',
        render(v: RewindJobExecutor[] | null) {
            return v?.[0]?.start ? renderDatetime(v[0].start) : null
        },
    },
    {
        dataIndex: ['rewind_job_executors'],
        title: 'Окончание',
        render(v: RewindJobExecutor[] | null) {
            return v?.[0]?.end ? renderDatetime(v[0].end) : null
        },
    },
    {
        dataIndex: ['jobStatus'],
        title: 'Статус',
        width: 100,
        render(v) {
            return <JobStatusCell jobStatus={v} />
        },
    },
    { dataIndex: ['approved_by', 'username'], title: 'Подтвержден', width: 120 },
    {
        dataIndex: 'actions',
        title: 'Действия',
        width: 120,
        fixed: 'right',
        render(_v, record) {
            return <ActionsCell rewindJob={record} />
        },
    },
]
